// src/App.jsx
import React, { useState } from 'react';
import Login from './components/Login';
import Canvas from './components/Canvas';
import './App.css';

function App() {
  // Use sessionStorage to keep the user logged in for the browser session
  const [password, setPassword] = useState(sessionStorage.getItem('app-password') || null);

  const handleLoginSuccess = (enteredPassword) => {
    sessionStorage.setItem('app-password', enteredPassword);
    setPassword(enteredPassword);
  };

  return (
    <div className="App">
      {!password ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <Canvas password={password} />
      )}
    </div>
  );
}

export default App;